var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21199",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Profile"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Profile",
    d: "M6 17.26c0-2.177 2.994-2.721 6.5-2.721 3.525 0 6.5.564 6.5 2.74S16.006 20 12.5 20C8.975 20 6 19.436 6 17.26zm2.2-9.027A4.252 4.252 0 0112.5 4a4.234 4.234 0 110 8.467 4.253 4.253 0 01-4.3-4.234z"
  }))));
}
export default SvgPersonalIcon;